import React, { useRef, useEffect, useState } from "react";

import Card from "./shared/Card";
import UploadComponent from "./UploadComponent";
import VideoDropdown from "./VideoDropdown";
import VideoPlayer from "./VideoPlayer";
import PlusButton from "./shared/PlusButton";

const SourceVideo = ({ playing, sourceVideo, setSourceVideo, small=false }) => {
    const [uploadVisible, setUploadVisible] = useState(false);

    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            if (playing) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    }, [playing, videoRef]);

    console.log("sourceVideo", sourceVideo);

    const handleUploadVideo = (uploadedMedia) => {
        setSourceVideo(uploadedMedia);
        setUploadVisible(false);
    };

    return (
        <Card>
            {!uploadVisible && (
                <div className="flex flex-grow w-full items-center space-x-4">
                    <div className="flex-grow">
                        <VideoDropdown onSelect={(video) => setSourceVideo(video)} />
                    </div>
                    <PlusButton
                        onClick={() => setUploadVisible(true)}
                        className="mb-4"
                    />
                </div>


            )}

            {uploadVisible && (
                <div className="w-full relative">
                    <UploadComponent
                        mediaType="video"
                        setSourceMedia={handleUploadVideo}
                        uploadText="Upload a video"
                        setUploadVisible={setUploadVisible}

                    //   onUploadSuccess={handleImageUploadSuccess} 
                    />
                </div>
            )}
            {sourceVideo && (
                <VideoPlayer
                    videoUrl={sourceVideo.s3_url}
                    ref={videoRef}
                    playing={playing}
                    small={small}
                />

            )}
        </Card>
    );
}

export default SourceVideo;